function onSwymLoadCallback(swat) {
  const ROOT_SELECTOR = '.swym-sfl-list-container';
  const PRODUCT_SELECTOR = '.swym-sfl-container, .swym-sfl-list-product-item';

  function updateSFLVisibility() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const hasProducts = !!root.querySelector(PRODUCT_SELECTOR);
    root.style.display = hasProducts ? '' : 'none';
    root.setAttribute('aria-hidden', hasProducts ? 'false' : 'true');
  }

  function init() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return setTimeout(init, 200);

    updateSFLVisibility();

    new MutationObserver(updateSFLVisibility).observe(root, {
      childList: true,
      subtree: true
    });
    document.addEventListener('sw:addedtoSFL', updateSFLVisibility);
    document.addEventListener('sw:removedfromSFL', updateSFLVisibility);
    document.addEventListener('sw:ready', updateSFLVisibility);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
}

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(onSwymLoadCallback);
